/* Mother Nurture – Affiliate message inside the existing announcement-bar slider.
   Affiliate id is mapped to code in the theme editor. No API calls or discount changes.
   Run synchronously after the section markup (before deferred theme.js upgrades the
   native announcement-bar element) so the affiliate message is first without flash.
*/
(function () {
  'use strict';
  const STORAGE_KEY = 'mn_upm_affiliate_id';

  function affiliateIdFromUrl() {
    const referral = new URLSearchParams(window.location.search).get('sca_ref');
    if (!referral || !/^\d+\.[a-z0-9_-]+$/i.test(referral)) return null;
    return referral.split('.', 1)[0];
  }

  function affiliateIdForSession() {
    const fromUrl = affiliateIdFromUrl();
    if (fromUrl) {
      try { sessionStorage.setItem(STORAGE_KEY, fromUrl); } catch (_) { /* blocked storage */ }
      return fromUrl;
    }
    try { return sessionStorage.getItem(STORAGE_KEY); } catch (_) { return null; }
  }

  function findCoupon(mappingText, affiliateId) {
    if (!mappingText || !affiliateId) return null;
    for (const line of mappingText.split(/\r?\n/)) {
      const trimmed = line.trim();
      if (!trimmed || trimmed.startsWith('#')) continue;
      const match = trimmed.match(/^(\d+)\s*[=:|]\s*([a-z0-9_-]+)\s*$/i);
      if (match && match[1] === affiliateId) return match[2];
    }
    return null;
  }

  function renderMessage(node, template, code) {
    if (!node) return;
    // Split on {code} and insert the code as a bold text node (no HTML injection).
    const parts = (template || '5 % Rabatt mit Code {code} für dich!').split(/(\{code\})/gi);
    node.replaceChildren();
    for (const part of parts) {
      if (part.toLowerCase() === '{code}') {
        const strong = document.createElement('strong');
        strong.textContent = code;
        node.appendChild(strong);
      } else {
        node.appendChild(document.createTextNode(part));
      }
    }
  }

  function updateAnnouncement(section) {
    const root = section || document.querySelector('[data-mn-affiliate-announcement]');
    if (!root) return;
    const affiliateSlide = root.querySelector('.mn-affiliate-announcement-slide');
    if (!affiliateSlide) return;

    const affiliateId = affiliateIdForSession();
    const code = findCoupon(root.getAttribute('data-mn-affiliate-map'), affiliateId);
    const activeCount = parseInt(root.getAttribute('data-mn-announcement-count') || '1', 10);
    const visible = Boolean(code);

    affiliateSlide.hidden = !visible;
    affiliateSlide.setAttribute('aria-hidden', visible ? 'false' : 'true');
    root.toggleAttribute('data-mn-affiliate-active', visible);

    if (visible) {
      renderMessage(affiliateSlide.querySelector('[data-mn-affiliate-message]'), root.getAttribute('data-mn-affiliate-message-template'), code);
    }

    // The affiliate slide appears BEFORE normal slides. Set initial selection to
    // the first VISIBLE slide, while retaining the theme's native autoplay.
    const normalSlides = root.querySelectorAll('.mn-regular-announcement-slide');
    affiliateSlide.classList.toggle('is-selected', visible);
    normalSlides.forEach(function (slide, index) {
      slide.classList.toggle('is-selected', !visible && index === 0);
    });

    const controls = root.querySelectorAll('carousel-prev-button, carousel-next-button');
    controls.forEach(function (control) {
      control.hidden = !visible && activeCount <= 1;
    });
  }

  // Called immediately while HTML is parsing: no free-shipping slide flashes first
  // when a visitor lands using a recognised referral URL.
  updateAnnouncement();

  // The Shopify editor can re-render this section without a full page load.
  if (!window.mnAffiliateAnnouncementListenersAdded) {
    window.mnAffiliateAnnouncementListenersAdded = true;
    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target.querySelector('[data-mn-affiliate-announcement]');
      if (root) updateAnnouncement(root);
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) updateAnnouncement();
    });
  }
})();
